import React from 'react';
import { Anchor, Box, Heading, Page, PageContent } from 'grommet';
import { Outlet } from 'react-router-dom';

const InternalPages = {
    'Resume Reviewers': '/internal-review/resume-reviewer-history',
    Reporting: '/internal-review/reporting',
    CADI: '/internal-review/cadi',
};

export const InternalReviewDashboard = () => {
    return (
        <Page
            kind="full"
            pad={{ top: '30px', horizontal: 'medium', bottom: '30px' }}>
            <PageContent>
                <Heading level="2">Internal</Heading>
                <Box
                    background="enrich-green-light"
                    direction="row"
                    gap="small">
                    {Object.entries(InternalPages).map((page) => {
                        return (
                            <Box pad="small" key={page[0]}>
                                <Anchor label={page[0]} href={page[1]} />
                            </Box>
                        );
                    })}
                </Box>
                <Outlet />
            </PageContent>
        </Page>
    );
};
